import React, { Component, Fragment, useState } from 'react';
import { dataContact } from './dataContact';

import './styles.scss';

import isoDarsur from '../../assets/img/brand/iso-darsur.jpg'


export const WhatsappSelect = () => {

  const [selectVisible, setSelectVisible] = useState(false);

  const vendedores = dataContact.vendedores;
  const indiceAleatorio = Math.floor(Math.random() * vendedores.length);
  const vendedorSeleccionado = vendedores[indiceAleatorio];

  return (
    <div className='wsp__wrapper'>
        <div className={`wsp__select ${selectVisible ? 'show' : ''}`}>
            <div className="wsp__select__header">
                <div className="wsp__close-btn close" onClick={() => setSelectVisible(false)}>
                    <i className="fa fa-times text-right"></i>
                </div>
                <div className='mt-2'>Hola! Haz clic en uno de nuestros miembros de abajo para chatear por <strong>WhatsApp</strong>.</div>
            </div>
            <div className="wsp__select__list">
                <a target='_blank' href={`https://web.whatsapp.com/send/?phone=54${vendedorSeleccionado.telefono}&text=${vendedorSeleccionado.salutacion} ${vendedorSeleccionado.nombre}, `} className="wsp__select__item">
                    <img src={isoDarsur} alt="" className="wsp__select__avatar" />
                    Ventas
                </a>
            </div>
            <div className="wsp__select__list">
                <a target='_blank' href={`https://web.whatsapp.com/send/?phone=54${dataContact.contacto_administracion.telefono}&text=${dataContact.contacto_administracion.salutacion}, `} className="wsp__select__item">
                <img src={isoDarsur} alt="" className="wsp__select__avatar" />
                    Administración
                </a>
            </div>
            <div className="wsp__select__list">
                <a target='_blank' href={`https://web.whatsapp.com/send/?phone=54${dataContact.contacto_deposito.telefono}&text=${dataContact.contacto_administracion.salutacion}, `} className="wsp__select__item">
                <img src={isoDarsur} alt="" className="wsp__select__avatar" />
                    Depósito
                </a>
            </div>
        </div>
        <div className="wsp__icon" onClick={() => setSelectVisible(!selectVisible)}>
           <i class="fa fa-whatsapp"></i>
        </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/WhatsappSelect/WhatsappSelect.js